export const DEFAULT_OPENING_HOURS = {
  monday: [{ start: 7.0, end: 17.0 }],
  tuesday: [{ start: 7.0, end: 17.0 }],
  wednesday: [{ start: 7.0, end: 17.0 }],
  thursday: [{ start: 7.0, end: 17.0 }],
  friday: [{ start: 7.0, end: 17.0 }],
  saturday: [],
  sunday: [],
};
